import { Grid } from "@material-ui/core";
import { Box, Typography } from "@mui/material";
import {
  Bell,
  CheckSquareOffset,
  CircleNotch,
  Columns,
  Key,
  Browsers,
  LineSegments,
  Users,
} from "phosphor-react";
import { useEffect, useState } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { fget } from "../../../API/callsAPI";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import ApiKeysSettingsOverview from "../APIKeysSettingsOverview/ApiKeysSettingsOverview";
import FieldTemplatesSettingsOverview from "../FieldTemplatesSettings/FieldTemplatesSettingsOverview";
import WebhookTable from "../GeneralSettingOverview/ChannelConnectorConfiguration/WebhookTable";
import WebhookItemsTable from "../GeneralSettingOverview/Webhooks/WebhookItemsTable";
import WebhooksOverview from "../GeneralSettingOverview/Webhooks/WebhooksOverview";
import ManageUsersSettingsOverview from "../ManageUsersSettingsOverview/ManageUsersSettingsOverview";
import NotificationSettingsOverview from "../NotificationSettings/NotificationSettingsOverview";
import ProjectDetailsSettingsOverview from "../ProjectDetailsSettings/ProjectDetailsSettingsOverview";
import StatusSettingOverview from "../StatusSettingOverview/StatusSettingOverview";
import TaskTemplateSettingOverview from "../TaskTemplateSettings/TaskTemplateSettingOverview/TaskTemplateSettingOverview";
import useStyles from "./SettingOverview.style";
import NavigationsSettings from "../NavigationsSettings/NavigationSettingOverview/NavigationsSettings";

const NewSettingsOverview = (props) => {
  const history = useHistory();
  const currentTab = props.params.settingsType;
  const tabId = props.params.id;
  const searchParams = new URLSearchParams(useLocation().search);
  const [projectDetails, setProjectDetails] = useState({});
  // const page = searchParams.get("page");
  // console.log(page);

  const classes = useStyles();
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [trackableClasses, setTrackableClasses] = useState([]);

  const handleTabChange = (tabName) => {
    history.push(`/${props.params.projectId}/settings/${tabName}`);
  };

  const defineCurrentTabClassName = (tabName) => {
    return tabName === currentTab
      ? classes.selectedSetting
      : classes.singleSettingsFlex;
  };

  useEffect(() => {
    fetchTrackableClass();
    return () => {};
  }, []);

  const fetchTrackableClass = async () => {
    try {
      const trackableClass = await fget({
        url: `trackables/trackable-classes/`,
      });
      setTrackableClasses(trackableClass.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    async function getProjectObject() {
      try {
        const projectDetailObject = await fget({
          url: `project/${props.params.projectId}/`,
        });
        if (projectDetailObject.status === 200) {
          setProjectDetails(projectDetailObject.data);
        }
      } catch (error) {
        // setIsUserInfoLoading(false);
      }
    }
    getProjectObject();
  }, [props.params.projectId]);

  return (
    <div
      style={{
        height: "100%",
      }}
    >
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <div className={classes.root}>
        <div
          className={classes.divChildContent1}
          style={{
            borderBottom: "2px solid #6C65D9",
            paddingBottom: "6px",
          }}
        >
          <span className={classes.settingTitle}>Movie Colab Settings</span>
        </div>
        <div>
          <Grid container spacing={2}>
            <Grid item md={2}>
              <Box
                className={classes.notificationMenu}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div
                  className={defineCurrentTabClassName("notifications")}
                  onClick={() => handleTabChange("notifications")}
                >
                  <Bell size={20} />
                  <Typography>Notifications</Typography>
                </div>
                <div
                  className={defineCurrentTabClassName("navigation")}
                  onClick={() => handleTabChange("navigation")}
                >
                  <Browsers size={20} />
                  <Typography>Navigation</Typography>
                </div>
                <Box>
                  <Typography className={classes.grayText}>
                    Pipeline Settings
                  </Typography>
                  <Box className={classes.multipleSettingsContainer}>
                    <div
                      className={defineCurrentTabClassName("status")}
                      onClick={() => handleTabChange("status")}
                    >
                      <CircleNotch size={20} />
                      <Typography>Statuses</Typography>
                    </div>
                    <div
                      className={defineCurrentTabClassName("taskTemplate")}
                      onClick={() => handleTabChange("taskTemplate")}
                    >
                      <CheckSquareOffset size={20} />
                      <Typography>Tasks Templates</Typography>
                    </div>
                  </Box>
                </Box>
                <div>
                  <Typography className={classes.grayText}>
                    Project Settings
                  </Typography>
                  <div className={classes.multipleSettingsContainer}>
                    {/* <div
                      className={defineCurrentTabClassName("project-details")}
                      onClick={() => handleTabChange("project-details")}
                    >
                      <Info size={20} />
                      <Typography>Project Details</Typography>
                    </div> */}

                    <div
                      className={defineCurrentTabClassName("webhooks")}
                      onClick={() => handleTabChange("webhooks")}
                    >
                      <LineSegments size={20} />
                      <Typography>Webhooks</Typography>
                    </div>
                    <div
                      className={defineCurrentTabClassName("api-keys")}
                      onClick={() => handleTabChange("api-keys")}
                    >
                      <Key size={20} />
                      <Typography>API Keys</Typography>
                    </div>
                    <div
                      className={defineCurrentTabClassName("field-templates")}
                      onClick={() => handleTabChange("field-templates")}
                    >
                      <Columns size={20} />
                      <Typography>Field Templates</Typography>
                    </div>
                    {/* <div className={classes.singleSettingsFlex}>
                      <Warning size={20} />
                      <Typography>Archive & Delete</Typography>
                    </div> */}
                  </div>
                </div>
                <div>
                  <Typography className={classes.grayText}>
                    Users & Access Settings
                  </Typography>
                  <div className={classes.multipleSettingsContainer}>
                    {/* <div className={classes.singleSettingsFlex}>
                      <LockKey size={20} />
                      <Typography>Access Controls</Typography>
                    </div> */}
                    <div
                      className={defineCurrentTabClassName("manage-users")}
                      onClick={() => handleTabChange("manage-users")}
                    >
                      <Users size={20} />
                      <Typography>Manage Users</Typography>
                    </div>
                  </div>
                </div>
                {/* <div>
                  <Typography className={classes.grayText}>
                    Experimental Settings
                  </Typography>
                  <div className={classes.multipleSettingsContainer}>
                    <div className={classes.singleSettingsFlex}>
                      <CircleNotch size={20} />
                      <Typography>Movie Colab Agents</Typography>
                    </div>
                  </div>
                </div> */}
              </Box>
            </Grid>
            <Grid item md={10}>
              {currentTab === "status" ? (
                <StatusSettingOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                />
              ) : currentTab === "notifications" ? (
                <NotificationSettingsOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                />
              ) : currentTab === "taskTemplate" ? (
                <TaskTemplateSettingOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                  trackableClasses={trackableClasses}
                />
              ) : currentTab === "project-details" ? (
                <ProjectDetailsSettingsOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                  trackableClasses={trackableClasses}
                />
              ) : currentTab === "webhooks" ? (
                tabId ? (
                  <WebhookItemsTable
                    setSnackValue={setSnackValue}
                    projectId={props.params.projectId}
                  />
                ) : (
                  <WebhooksOverview
                    setSnackValue={setSnackValue}
                    projectId={props.params.projectId}
                  />
                )
              ) : currentTab === "api-keys" ? (
                <ApiKeysSettingsOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                  trackableClasses={trackableClasses}
                />
              ) : currentTab === "manage-users" ? (
                <ManageUsersSettingsOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                  trackableClasses={trackableClasses}
                  projectDetails={projectDetails}
                />
              ) : currentTab === "field-templates" ? (
                <FieldTemplatesSettingsOverview
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                  trackableClasses={trackableClasses}
                />
              ) : currentTab === "navigation" ? (
                <NavigationsSettings
                  setSnackValue={setSnackValue}
                  projectId={props.params.projectId}
                />
              ) : (
                <WebhookTable />
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default NewSettingsOverview;
